export default "__VITE_ASSET__CDqtMSjU__"